export const CalendarLeft = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.78 13.0244C12.5314 14.4255 14.6759 16.5588 16.1172 19.4416L13.8811 20.5596C12.6558 18.1088 10.8002 16.2421 9.21828 14.9766C8.43174 14.3474 7.72502 13.8765 7.21904 13.5651C6.96641 13.4097 6.76485 13.2946 6.6297 13.2201C6.56215 13.1828 6.51129 13.1557 6.47903 13.1388L6.44488 13.121L6.44016 13.1186L6.43956 13.1183C6.43959 13.1183 6.43962 13.1184 6.44016 13.1173L6.44013 10.8838C6.43959 10.8828 6.43956 10.8828 6.43953 10.8828L6.44013 10.8825L6.44485 10.8801L6.47901 10.8624C6.51126 10.8455 6.56213 10.8184 6.62967 10.7811C6.76483 10.7065 6.96639 10.5915 7.21902 10.436C7.725 10.1246 8.43173 9.65372 9.21827 9.02447C10.8002 7.75889 12.6558 5.89218 13.8811 3.44141L16.1172 4.55941C14.6759 7.44214 12.5314 9.57551 10.78 10.9766C10.284 11.3735 9.81557 11.7147 9.39783 12.0005C9.81557 12.2864 10.284 12.6276 10.78 13.0244Z"
        fill="#070707"
      />
    </svg>
  );
};

export const CalendarRight = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.22 13.0244C11.4686 14.4255 9.32414 16.5588 7.88281 19.4416L10.1189 20.5596C11.3442 18.1088 13.1998 16.2421 14.7817 14.9766C15.5683 14.3474 16.275 13.8765 16.781 13.5651C17.0336 13.4097 17.2351 13.2946 17.3703 13.2201C17.4378 13.1828 17.4887 13.1557 17.521 13.1388L17.5551 13.121L17.5598 13.1186L17.5604 13.1183C17.5604 13.1183 17.5604 13.1184 17.5598 13.1173L17.5599 10.8838C17.5604 10.8828 17.5604 10.8828 17.5605 10.8828L17.5599 10.8825L17.5551 10.8801L17.521 10.8624C17.4887 10.8455 17.4379 10.8184 17.3703 10.7811C17.2352 10.7065 17.0336 10.5915 16.781 10.436C16.275 10.1246 15.5683 9.65372 14.7817 9.02447C13.1998 7.75889 11.3442 5.89218 10.1189 3.44141L7.88281 4.55941C9.32413 7.44214 11.4686 9.57551 13.22 10.9766C13.716 11.3735 14.1844 11.7147 14.6022 12.0005C14.1844 12.2864 13.716 12.6276 13.22 13.0244Z"
        fill="#070707"
      />
    </svg>
  );
};
